// platePlugins.js - 简化版本，保持兼容性
// 这个文件暂时保留为空，等待将来迁移到纯 Slate 插件

// 临时导出空的插件配置，以避免构建错误
export const plugins = [];

// 导出一些常用的标记类型常量
export const MARK_BOLD = 'bold';
export const MARK_ITALIC = 'italic';
export const MARK_UNDERLINE = 'underline';
export const ELEMENT_IMAGE = 'image';
export const ELEMENT_LINK = 'link';
export const ELEMENT_PARAGRAPH = 'paragraph';
